module.exports = __webpack_public_path__ + "img/catherine_750x750.f93ece1a.jpg";